// external imports
import { useEffect, useContext } from 'react';

// internal imports
import { pipelineContext } from '../../contexts/pipelineContext';
import formatDate from '../../helpers/formatDate';
import { renderDownloadPostQCDataBtn } from './helpers';

const QCReport = ({ props }) => {
	const { postQCData, qcType, straightToUpload } = useContext(pipelineContext);
	const pipelineContextQCReport = useContext(pipelineContext);

	useEffect(() => {
		pipelineContextQCReport.setComm('smelters');
	}, []);

	const ReportField = ({ label, value }) => (
		<div className="col-sm-6">
			<div className="py-2 border-bottom">
				<div className="small text-muted text-uppercase fw-semibold">
					{label}
				</div>
				<div className="fw-semibold">{value}</div>
			</div>
		</div>
	);

	const date = new Date().toLocaleString('en-GB').slice(0, 10);
	const time = new Date().toLocaleString('en-GB').slice(11, 17);
	const userHandle = `${props.authProps.userAttributes.givenName.toLowerCase()}.
						${props.authProps.userAttributes.familyName.toLowerCase()}`;

	const sites = [...new Set(postQCData.map((capture) => capture.site_id))];
	console.log(sites);
	const uniqueCaptures = [...new Set(postQCData.map((capture) => capture.id))];
	const captures = postQCData.map((capture) => capture.id);

	const capturesSorted = [...postQCData].sort(
		(a, b) => new Date(a.captured) - new Date(b.captured)
	);

	const startDate = formatDate(capturesSorted[0]?.captured);
	const endDate = formatDate(capturesSorted.at(-1)?.captured);

	return (
		<>
			<hr></hr>
			<div className=" ms-4">
				<h1>QC Report</h1>

				<section
					className="card border-0 fs-5 mt-4"
					style={{ backgroundColor: '#f8f9fa' }}
				>
					<div className="card-body p-4">
						<div className="row gx-4">
							<ReportField label="Sites processed" value={sites?.length} />
							<ReportField
								label="Unique captures processed"
								value={uniqueCaptures?.length}
							/>
							<ReportField label="QC category" value={qcType} />
							<ReportField
								label="Captures processed"
								value={captures?.length}
							/>

							<ReportField
								label="Upload type"
								value={straightToUpload ? 'straight to upload' : 'From QC'}
							/>
							<ReportField label="Date run" value={`${date} at ${time}`} />
							<ReportField label="Run by" value={userHandle} />
							<ReportField
								label="Commodity"
								value={pipelineContextQCReport.comm}
							/>
							<ReportField
								label="Capture range"
								value={`${startDate} — ${endDate}`}
							/>
						</div>

						<div className="row gx-4 mt-5">
							{renderDownloadPostQCDataBtn(postQCData)}
						</div>
					</div>
				</section>
			</div>
		</>
	);
};

export default QCReport;
